import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule,Routes } from '@angular/router';
import { CreditScoreCLAComponent } from './credit-score-CLA/credit-score-cla.component';
import { OrganisationDetailComponent } from './organisation-detail/organisation-detail.component';


const routes: Routes = [
  {
    path : 'credits',
    children: [
      { path: '', component: CreditScoreCLAComponent },
      { path: 'credit-details', component: OrganisationDetailComponent }
    
    ]
  }

];
@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes),
    CommonModule
  ],
  exports: [RouterModule]
})
export class CreditsRoutingModule { }
